<template>
  <div class="app-nav-bar">
    <top-banner />
    <v-app-bar flat color="white" class="app-nav-bar-box">
      <div class="d-flex align-center brand-box">
        <v-img :src="business.getBusinessImage()" width="32" :alt="business.name" />
        <LimitedText :key="`business-name-${business.name}`" class="app-name" :text="business.name" :max-length="13" />
      </div>
      <div class="links">
        <div class="burger-btn" @click="handleToggleLeftSide"> </div>
      </div>
      <span class="page-title">
        <slot name="nav-page-title" :title="getPageName">
          {{ getPageName }}
        </slot>
      </span>
      <slot name="nav-links" />
      <v-spacer />

      <div class="text-center">
        <NavMenu :username="getUserName" />
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import Vue from "vue";
import "./styles.scss";
import TopBanner from "./banner/index.vue";
import NavMenu from "./menu/index.vue";
import { $eventHub } from "@/components";
import { mapGetters } from "vuex";
import { EventConstraints } from "@/enums/events.enum";

const NavBar = Vue.extend({
  name: "NavBar",

  components: { TopBanner, NavMenu },

  computed: {
    ...mapGetters({
      session: "User/session",
      OOCSession: "OOCUsers/oocSession",
      business: "Business/business",
    }),
    /**
     * Handle get username
     * @return {string}
     */
    getUserName() {
      const session = this.session || this.OOCSession;
      return `${session?.first_name || ""} ${session?.last_name || ""}`;
    },

    /**
     * Handle to get the route page name
     * @return {string}
     */
    getPageName() {
      return this.$t(this.$router?.currentRoute?.name ?? "");
    },
  },

  methods: {
    /**
     * Handle toggle left side nave min/max
     * @return {void}
     */
    handleToggleLeftSide() {
      $eventHub.$emit(EventConstraints.TOGGLE_LEFT_SIDE_NAV);
    },
  },
});
export default NavBar;
</script>
